export const APP_VERSION = "5.4.0";
export const APP_NAME = "Sisbagal";
export const FULL_APP_NAME =
    "Sistema de información de servizos básicos de augas de Galicia";
